import { render } from "./FakeReview.vue?vue&type=template&id=5b1becb0&scoped=true"
import script from "./FakeReview.vue?vue&type=script&lang=js"
export * from "./FakeReview.vue?vue&type=script&lang=js"

import "./FakeReview.vue?vue&type=style&index=0&id=5b1becb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1becb0"]])

export default __exports__